import type {Reducer} from "redux";
import {combineReducers} from "redux";
import {feedReducer} from "@atg-casino-shared/data-access-feed";
import {collectionReducer} from "@atg-casino-shared/data-access-collection";
import {gameReducer} from "@atg-casino-shared/data-access-game";
import {tagReducer} from "@atg-casino-shared/data-access-tag";
// WAIT FOR: figure out a way to break this 1 to 1 circular
// NO DONT CARE ABOUT THIS BECAUSE THE GAME FLOW WILL BE REMOVED IN FAVOR OF THE MODERN WAY OF LAUNCHING A GAME
// eslint-disable-next-line @nx/enforce-module-boundaries
import {gameFlowReducer} from "@atg-casino-shared/data-access-game-flow";

export const casinoReducer: Reducer<any, any> = combineReducers({
    games: gameReducer,
    tags: tagReducer,
    collections: collectionReducer,
    game: gameFlowReducer,
    feeds: feedReducer,
});
